<div class="pt-3 pb-5 faq">
  <app-section-container>
    <div class="faq-section m-auto pb-5">
      <div class="faq mb-4">
        <app-card-chips>FAQs</app-card-chips>
      </div>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <app-section-heading>
          <span class="text__black">Have Questions?</span>
        </app-section-heading>
        <div
          class="view-all-chip cursor-pointer"
          [routerLink]="['/', routes.home, routes.faqs]"
        >
          <app-card-chips>
            <span ngProjectAs="[chip-icon]">
              <img
                src="images/view-all.svg"
                height="24"
                width="25"
                alt="view-all"
              />
            </span>
            View All</app-card-chips
          >
        </div>
        <div
          class="view-all-text text__black"
          [routerLink]="['/', routes.home, routes.faqs]"
        >
          View All
        </div>
      </div>
      <ng-container *ngIf="faqList?.length; else noRecordFound">
        @for(faq of faqList; track faq){
        <app-faq-accordion
          [faqQuestion]="faq.question"
          [faqAnswer]="faq.answer"
          [faqId]="faq.weight"
          [faqIsExpanded]="false"
        ></app-faq-accordion>
        }
      </ng-container>
      <ng-template #noRecordFound>
        <ng-container *ngIf="isErrorFetchFAQs; else noData">
          <app-couldnt-load-data
            minHeight="25rem"
            (onRetry)="getFAQList()"
          ></app-couldnt-load-data>
        </ng-container>
        <ng-template #noData>
          <app-no-record-found></app-no-record-found>
        </ng-template>
      </ng-template>
    </div>
  </app-section-container>
</div>
